export interface IApplicationTypeForm {
  applicationType: ApplicationTypeByMembers | '';
}

export enum ApplicationTypeByMembers {
  SOLE_APPLICATION = 'SOLE_APPLICATION',
  JOINT_APPLICATION = 'JOINT_APPLICATION',
}
